import { useNavigate, useLocation, Outlet } from "react-router-dom";
import authService from "../services/authService";
import styles from "./checkoutlayout.module.css";
import { Banner, BreadCrumb, SubHeadingTitle } from "./shared/index";

const CheckoutLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { pathname } = location;
  const isLoggedin = authService.isLoggedIn();

  const pageConfig = {
    cart: {
      breadcrumbLabel: "Shopping Cart",
      bannerHeading: "Daily freshness made for you",
      bannerImage:
        "https://t3.ftcdn.net/jpg/09/12/83/30/240_F_912833087_PfQGVPf6nfk1ablZpIhajFzKnOGYKQFI.jpg",
    },

    checkout: {
      breadcrumbLabel: "Address Checkout",
      bannerHeading: "Daily freshness made for you",
      bannerImage:
        "https://t4.ftcdn.net/jpg/05/15/80/09/240_F_515800945_SK7WwuVKA8xAIMkLJFTkjj1RqNrEBkJE.jpg",
    },

    prescription: {
      breadcrumbLabel: "Upload Prescription",
      bannerHeading: "Upload your prescription for verification",
      bannerImage:
        "https://media.gettyimages.com/id/149262483/photo/close-up-of-doctors-hand-giving-prescription-to-patient-studio-shot.jpg?s=612x612&w=0&k=20&c=nfpBJNywH5JvH_x5gjYhvZC2eXQzYgwT_PZ89yGAFfM=",
    },

    payment: {
      breadcrumbLabel: "Shipping & Payment Summary",
      bannerHeading: "Daily freshness made for you",
      bannerImage:
        "https://t4.ftcdn.net/jpg/07/43/05/01/240_F_743050189_ZUngBiSqkCY5NmhWNZZT2FjykdpPHUwX.jpg",
    },

    success: {
      breadcrumbLabel: "Product Tracking",
      bannerHeading: "Same Day Delivery . multiple payment options",
      bannerImage:
        "https://media.istockphoto.com/id/960871382/photo/assortment-of-the-fresh-vegetables.jpg?s=612x612&w=0&k=20&c=wUJcQBMWzoxwS_WNhCeoS0HaSMfS7IAHO_9uIg7WK0c=",
    },

    "order-success": {
      breadcrumbLabel: "Product Tracking",
      bannerHeading: "Same Day Delivery . multiple payment options",
      bannerImage:
        "https://media.istockphoto.com/id/960871382/photo/assortment-of-the-fresh-vegetables.jpg?s=612x612&w=0&k=20&c=wUJcQBMWzoxwS_WNhCeoS0HaSMfS7IAHO_9uIg7WK0c=",
    },
  };

  const key = pathname.split("/").pop();
  const config = pageConfig[key] || pageConfig.checkout;

  /*
   * LOGGED OUT CART
   *
   * Only show empty cart message.
   * No breadcrumb
   * No banner
   * No Outlet
   */
  if (!isLoggedin && key === "cart") {
    return (
      <div className={`${styles.checkoutWrapper} ${styles.loggedOutCart}`}>
        <div className={styles.emptyCartContent}>
          <h2>Your Cart is Empty</h2>

          <p>
            Looks like you haven't added anything to your cart yet.
          </p>

          <button
            type="button"
            className={styles.startShoppingButton}
            onClick={() => navigate("/shop")}
          >
            Start Shopping
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.checkoutWrapper}>
      <BreadCrumb
        customPaths={[
          {
            label: config.breadcrumbLabel,
            path: "/",
          },
        ]}
      />

      <Banner
        heading={config.bannerHeading}
        imageUrl={config.bannerImage}
      />

      {!isLoggedin ? (
        <SubHeadingTitle
          subTitle="Please login to check cart items & proceed to checkout..."
          style={styles.cartError}
        />
      ) : (
        <>
          <Outlet />
        </>
      )}
    </div>
  );
};

export default CheckoutLayout;